export default __webpack_public_path__ + "static/media/kindly-empowerment.7150b99b.svg";